import React, { Component } from 'react';
import LoadingComponent from '../../commonComponents/LoadingComponent';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import CallAPI from '../../commonComponents/AxiosHelper';
class StepTwo extends Component {
    constructor(props) {
        super(props);
        this.state = { columns: this.props.data };
        this.handleButton = this.handleButton.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        this.updateStates(nextProps);
    }
    componentDidMount() {
        this.updateStates(this.props);
    }
    updateStates(finalProps) {
        this.setState({ columns: finalProps.data })
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }
    getData(e) {
        e.preventDefault();
        var that = this;
        var allData = [];
        this.state.columns.map(function (innerData, i) {
            var temp = {};
            temp.name = document.getElementById('metricNameTag' + i).value;
            temp.value = innerData.value;
            temp.metricPrefix = document.getElementById('metricPrefix' + i).value;
            temp.metricUnit = document.getElementById('metricUnit' + i).value;
            temp.numberShorten = document.getElementById('numberShorten' + i).value;
            temp.roundOff = document.getElementById('roundOff' + i).value;
            allData.push(temp);
        })

        if (confirm("Please Confirm to Update!")) {
            let siteId = localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null;
            let toolId = this.props.datasetValue;
            let url = '/app/metricdefination?siteId=' + siteId + '&toolId=' + toolId;
            CallAPI('post', url, allData, null, 0, function (response) {
                alert("Updated Successfully!");
                // location.reload();
                that.props.fetchSynonym();
            },this.props.authData);
        }
        return false;
    }

    handleButton(e) {
        if (e.target.id == "editMetric") {
            jQuery("#saveMetric").removeAttr('hidden');
            jQuery("#cancelMetric").removeAttr('hidden');
            jQuery("#editMetric").attr('hidden', true);
        }
        else if (e.target.id == "cancelMetric") {
            jQuery("#saveMetric").attr('hidden', true);
            jQuery("#cancelMetric").attr('hidden', true);
            jQuery("#editMetric").removeAttr('hidden');
        }
    }

    submitHandle() {
        let that = this;
        let params = {
            siteId: localStorage.Cookies ? JSON.parse(localStorage.Cookies).siteId : null,
            toolId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).value : null
        }
        // CallAPI('POST', '/metricdefination', that.state.metric.metric, params, 0, function (response) {
        //     alert("Successfully Submitted");
        //     location.reload();
        //     that.formData.formula.options = response.columns;
        //     that.setState({ metric: response, dataCount: 0 })
        // })

    }

    render() {
        if (this.state.columns) {
            var tableRow = [];
            var columns = this.state.columns;
            var previousvalueheader = null;
            var that = this;
            var metricPrefix = [{ name: "None", value: "none" }, { name: "Prefix", value: "true" }, { name: "Suffix", value: "false" }];
            var numberShorten = [{ name: "General", value: "in" }, { name: "Lakhs", value: "l" }, { name: "Crores", value: "cr" }, { name: "Thousands", value: "k" }, { name: "Millions", value: "m" }];

            columns.map(function (innerData, i) {
                var metricPrefixArray = metricPrefix.map(function (metricPrefixData, index) {
                    return (<option value={metricPrefixData.value} key={index}>{metricPrefixData.name}</option>)
                });
                var numberShortenArray = numberShorten.map(function (numberShortenData, index) {
                    return (<option value={numberShortenData.value} key={index}>{numberShortenData.name}</option>)
                });
                var tempTableRow = (
                    <tr key={i}>
                        <td><span className="tx-14">{innerData['name']}</span><input type="hidden" name={"metricNameTag" + i} defaultValue={innerData['name']} id={'metricNameTag' + i} /></td>
                        <td><input type='text' className='form-control' placeholder='Metric Unit' name={'metricUnit' + i} defaultValue={innerData['metricUnit']} id={'metricUnit' + i} /></td>
                        <td><select id={'metricPrefix' + i} defaultValue={innerData['metricPrefix']} className=' custom-select tableinputs' style={{ width: "150px" }} required>{metricPrefixArray}</select></td>
                        <td><select id={'numberShorten' + i} defaultValue={innerData['numberShorten']} className='custom-select tableinputs' style={{ width: "150px" }} required>{numberShortenArray}</select></td>
                        <td><input type='number' className='form-control' placeholder='Number roundoff' name={'roundOff' + i} defaultValue={innerData['roundOff']} id={'roundOff' + i} /></td>
                    </tr>
                )
                tableRow.push(tempTableRow);
            })
            return (
                <div id="main-content">
                    {/* <div className="d-flex flex-row ">
                        <button className='btn btn-sm btn-primary' type="submit">Submit</button>
                    </div> */}
                    <div className="d-flex flex-row">
                        <button id="editMetric" onClick={this.handleButton} className='btn btn-sm pd-x-15 btn-primary mg-l-auto mg-r-15' type="submit">Edit</button>
                        <button id="saveMetric" className='btn btn-sm btn-primary mg-l-auto' type="submit" onClick={this.submitHandle} hidden>Save</button>
                        <button id="cancelMetric" onClick={this.handleButton} className='btn btn-sm btn-primary mg-l-10 mg-r-15' type="submit" hidden >Cancel</button>
                    </div>
                <div className="responsive-table col-md-12 mg-t-20">
                    <form autoComplete='off' action="#" onSubmit={this.getData.bind(this)} style={{ marginTop: '-10px' }} name="metricfunction" id="metricfunction">
                        <table
                            className="table table-bordered"
                            style={{
                                width: '100%',

                            }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Metric Unit</th>
                                    <th>Metric Prefix</th>
                                    <th>Number Shorten</th>
                                    <th>Number Roundoff</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableRow}
                            </tbody>
                        </table>
                    </form>
                </div>
                </div>
            );
        } else {
            return (<LoadingComponent />);
        }
    }
}

export default StepTwo;